import Vue from 'vue'

Vue.mixin({
  data() {
    return {
      fieldRules: {
        required: v => !!v?.trim() || 'Required',
        maxLength(max) {
          return v => (v || '').length <= max || `Max length ${max}`
        },
        email: v => {
//          const pattern = /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i
//          const pattern = /^(\s)*[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i
          const pattern = /^((\s)*[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?(\s*,\s*|\s*$))*$/i
          return !v || pattern.test(v) || 'Invalid e-mail'
        },
        phone: v => {
          return true;
/*
//          const pattern = /\d{3}[- ]?\d{3}[- ]?\d{4}( x\d{4})?|x\d{4}/
          const pattern = /^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]\d{3}[\s.-]\d{4}$/
          return !v || pattern.test(v) || 'Invalid phone number'
          */
        }
      }
    }
  }
})